<template>
  <!-- TODO: create logic with isActive prop for BottomNavigationItems -->
  <SfBottomNavigation id="BootmNav1" class="navigation-bottom smartphone-only">
    <SfBottomNavigationItem :class="route.path == '/' ? 'sf-bottom-navigation__item--active' : ''" icon="home" size="20px"
      :label="$t('Home')" @click="handleHomeClick" />
    <SfBottomNavigationItem v-if="headerList && headerList.length" icon="menu" size="20px" :label="headerList[0].title"
      @click="handleGoLink(headerList[0])" />
    <SfBottomNavigationItem v-if="headerList && headerList.length > 1" icon="heart" size="20px"
      :label="headerList[1].title" @click="handleGoLink(headerList[1])" />
    <SfBottomNavigationItem v-if="headerList && headerList.length > 2" icon="profile" size="20px"
      :label="headerList[2].title" @click="handleGoLink(headerList[2])" />
    <!-- TODO: add logic for label - if on Home then Basket, if on PDC then AddToCart etc. -->
    <SfBottomNavigationItem v-if="headerList && headerList.length > 3" icon="tiles" size="20px"
      :label="headerList[3].title" @click="handleGoLink(headerList[3])" />
  </SfBottomNavigation>
</template>

<script>
import { SfBottomNavigation, SfIcon, SfCircleIcon, SfBadge } from "@storefront-ui/vue";
import { useUiState } from "~/composables";
import { useOCart, useUser, cartGetters } from "@bee-hole/coms";
import { computed, useRoute, useRouter } from "@nuxtjs/composition-api";

export default {
  components: {
    SfBottomNavigation,
    SfIcon,
    SfCircleIcon,
    SfBadge
  },
  setup(props, context) {
    const route = useRoute();
    const router = useRouter();
    const { toggleCartSidebar, toggleWishlistSidebar, toggleLoginModal, toggleMobileMenu, isMobileMenuOpen, toggleSearchItem, isSearchItemOpen } = useUiState();
    const { isAuthenticated } = useUser();
    const { cart } = useOCart();

    const headerList = computed(() => {
      return context?.root?.$options?.$mallConfig?.mall_web_config?.headeTop || [];
    });
    const handleAccountClick = async () => {
      if (isSearchItemOpen.value) {
        toggleSearchItem();
      }
      if (isAuthenticated.value) {
        const localeAccountPath = context.root.localePath({ name: "my-account" });
        return router.push(localeAccountPath);
      }
      toggleLoginModal();
    };

    const handleItemsClick = () => {
      toggleMobileMenu();
      // router.push(context.root.localePath("/c/0"));
      if (!isSearchItemOpen.value) {
        return false;
      }
      toggleSearchItem();
    };

    const handleHomeClick = () => {
      isMobileMenuOpen.value ? toggleMobileMenu() : false;
      router.push(context.root.localePath("/"));
      if (!isSearchItemOpen.value) {
        return false;
      }
      toggleSearchItem();
    };

    const cartTotalItems = computed(() => {
      const count = cartGetters.getTotalItems(cart.value);
      return count ? count.toString() : null;
    });

    const handleGoLink = (item) => {
      if (item.link.indexOf('http') !== -1) {
        return window.open(item.link, '_blank');
      } else {
        const localeAccountPath = context.root.localePath(item.link);
        return router.push(localeAccountPath);
      }
    };
    return {
      route,
      isMobileMenuOpen,
      toggleWishlistSidebar,
      toggleCartSidebar,
      toggleMobileMenu,
      cartTotalItems,
      handleAccountClick,
      handleHomeClick,
      handleItemsClick,
      headerList,
      handleGoLink
    };
  }
};
</script>
<style lang="scss" scoped>
on-bottom {
  --bottom-navigation-z-index: 9999999999;
}

.cart-button {
  position: relative;
  border: 3px solid #fff;
}

.cart-badge {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
<style lang="scss">
.sf-bottom-navigation {
  --bottom-navigation-z-index: 9999999999;
  z-index: var(--bottom-navigation-z-index)
}
#BootmNav1{
  .sf-bottom-navigation-item{
    padding: var(--spacer-xs) 0 0 0;
  }
  height: calc(var(--spacer-xs) + 3.75rem);
}
</style>
